import { Directive, ElementRef, Host, HostListener, Optional, Self } from '@angular/core';

@Directive({
  selector: '[number-strict]'
})
export class NumberStrictDirective {
  private readonly NON_DIGIT_REGEX: RegExp = new RegExp(/\D*$/g);
  private readonly DIGIT_REGEX: RegExp = new RegExp(/^[\d]*$/g);

  private readonly SPECIALS_KEY: string[] = ['Backspace'];

  private element: HTMLInputElement;

  private get value(): string {
    return this.element.value;
  }

  constructor(@Host() @Self() @Optional() hostInput: ElementRef<HTMLInputElement>) {
    this.element = hostInput.nativeElement;
  }

  @HostListener('keydown', ['$event']) onKeydown(event: KeyboardEvent): void {
    if (this.SPECIALS_KEY.includes(event.key)) {
      return;
    }
  }

  @HostListener('keyup', ['$event']) onKeyup(event: KeyboardEvent): void {
    if (this.SPECIALS_KEY.includes(event.key)) {
      return;
    } else if (!this.value.match(this.DIGIT_REGEX)) {
      this.element.value = this.value.slice(0, -1);
    }
  }
}
